import {
  HttpErrorResponse,
  HttpEvent,
  HttpEventType,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, OccEndpointsService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Observable, of, throwError } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { LoaderService } from './loader-service.service';
import { CacheService } from './shared/services/cache.service';
import { SharedService } from './shared/services/shared.service';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptorService implements HttpInterceptor {
  isLoggedIn: boolean = false;
  constructor(
    private readonly occEndPoint: OccEndpointsService,
    private readonly loader: LoaderService,
    private readonly user: UserAccountFacade,
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly cacheService: CacheService,
    private readonly sharedService: SharedService
  ) {
    this.authService.isUserLoggedIn().subscribe((res2) => {
      res2 ? (this.isLoggedIn = res2) : cacheService.clear();
    });
  }
  // LOADING SPINNER
  activeRequest = 0;

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const b2bCached = this.cacheService.cache.has('b2bUnits');
    const locationCached = this.cacheService.cache.has('locations');

    if (b2bCached && req.url.split('/').pop() === 'b2bUnits') {
      // Return cached response if available
      return of(this.cacheService.cache.get('b2bUnits'));
    }

    if (locationCached && req.url.split('/').pop() === 'locations') {
      // Return cached response if available
      return of(this.cacheService.cache.get('locations'));
    }
    // LOADING SPINNER
    if (this.activeRequest == 0) {
      this.loader.triggerLoader(true);
    }
    this.activeRequest++;

    req = req.clone({
      headers: req.headers.set('sap-commerce-cloud-user-id', this.getUserId()),
    });

    if (localStorage.getItem('punchout-sid-key') != null) {
      req = req.clone({
        headers: req.headers.set(
          'punchoutSid',
          localStorage.getItem('punchout-sid-key')
        ),
      });
    }
    if (
      sessionStorage.getItem('selectedLocations') != null &&
      !req.url.includes('/oauth')
    ) {
      let locValue = JSON.parse(sessionStorage.getItem('selectedLocations'));
      let defaultAcc = JSON.parse(sessionStorage.getItem('defaultLocation'));
      req = req.clone({
        headers: req.headers.set(
          'selectedLocations',
          locValue.length == 1
            ? locValue[0].accountNumber
            : defaultAcc[0].accountNumber
        ),
      });
    }
    //US-13693-My Formulary: Payer level formulary not displaying
    if (
      sessionStorage.getItem('selectedLocations') == null &&
      this.isLoggedIn &&
      !req.url.includes('/oauth')
    ) {
      let loggedInb2b = localStorage.getItem('accountId');
      if (loggedInb2b !== null) {
        let locValue = JSON.parse(loggedInb2b); //logged in B2Bunit
        req = req.clone({
          headers: req.headers.set('selectedLocations', locValue),
        });
      }
    }
    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        if (
          event.type === HttpEventType.Response &&
          req.url.split('/').pop() === 'token'
        ) {
          if (event?.body?.REDIRECT_URL !== undefined) {
            const url = (event as any)?.body?.REDIRECT_URL;
            this.cacheService.isUserLoggedIn.next(true);
            if (url !== undefined) {
              window.location.href = url;
            }
          }
        } else if (
          event.type === HttpEventType.Response &&
          req.url.split('/').pop() === 'b2bUnits' &&
          !this.cacheService.cache.has('b2bUnits')
        ) {
          this.cacheService.put('b2bUnits', event);
        } else if (
          event.type === HttpEventType.Response &&
          req.url.split('/').pop() === 'locations' &&
          !this.cacheService.cache.has('locations')
        ) {
          this.cacheService.put('locations', event);
        } else if (
          event.type === HttpEventType.Response &&
          req.url.includes('cms/pages?')
        ) {
          sessionStorage.setItem('pagesData', JSON.stringify(event.body));
          this.sharedService.matNrData.next(true);
        }
      }),
      catchError((err) => {
        let index = this.occEndPoint.getBaseUrl().indexOf('occ');
        if (err instanceof HttpErrorResponse) {
          if (
            err.status === 401 &&
            err.url ==
              this.occEndPoint.getBaseUrl().substring(0, index) +
                'authorizationserver/oauth/token'
          ) {
            window.location.reload();
            localStorage.removeItem('id_token');
          }
        }
        return throwError(err);
      }),
      finalize(() => {
        // LOADING SPINNER
        this.stopLoader();
      })
    );
  }
  // LOADING SPINNER
  stopLoader() {
    this.activeRequest--;
    if (this.activeRequest == 0) {
      this.loader.triggerLoader(false);
    }
  }
  getUserId() {
    if (
      JSON.parse(localStorage.getItem('spartacus⚿⚿auth')).userId === 'anonymous'
    ) {
      return 'anonymous';
    } else {
      return JSON.parse(localStorage.getItem('spartacus⚿⚿auth')).userId;
    }
  }

  handleBodyIn(req: HttpRequest<any>, tokenToAdd) {
    if (req.method.toLowerCase() == 'post' && req.url.includes('/entries')) {
      const obj = {};
      obj['selectedLocations'] = tokenToAdd;
    }
    return req;
  }
}